module.exports = __webpack_public_path__ + "img/Icon_Chevron_Down.b085830b.svg";